module.exports = __webpack_public_path__ + "img/setup-1.0b501298.webp";